import { render, staticRenderFns } from "./TabsContainerTablistTab.vue?vue&type=template&id=0ec38928&"
import script from "./TabsContainerTablistTab.vue?vue&type=script&lang=js&"
export * from "./TabsContainerTablistTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports